module.exports = __webpack_public_path__ + "img/section5-item2.ab78cdfa.svg";